"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _ripOut = _interopRequireDefault(require("rip-out"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Display Tab
 *
 * @class Tab
 * @displayName Tab
 * @public
 */
class Tab extends _react.Component {
  /**
   * Render the Tab. Depending on props.selected the tab is rendered as active.
   *
   * @returns {React.DOM} list element with tab caption as link
   * @private
   */
  render() {
    const props = this.props;
    const other = (0, _ripOut.default)(props, 'ariaControls');
    const itemClassName = ['ux-tab-item'].concat(props.className);
    const linkClassName = (0, _classnames.default)(props.design === 'underline' ? 'ux-tab-link-underline' : 'ux-tab-link', {
      active: props.selected
    });
    const ariaControls = props.selected === true ? props.ariaControls : null;
    const ariaSelectedTab = props.selected === true ? 'true' : 'false';
    return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, other, {
      className: itemClassName.join(' '),
      role: "presentation"
    }), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: linkClassName,
      role: "tab",
      "aria-selected": ariaSelectedTab,
      "aria-controls": ariaControls
    }, props.children));
  }
}

/**
 * Property validation.
 *
 * @type {Object}
 * @api public
 */
exports.default = Tab;
Tab.propTypes = {
  /** Classes applied to tab */
  className: _propTypes.default.string,
  /** Boolean of whether the tab is selected or not */
  selected: _propTypes.default.bool,
  /** Children elements of a tab */
  children: _propTypes.default.node,
  /** Accessibility attributes */
  ariaControls: _propTypes.default.string,
  /** Design of a tab */
  design: _propTypes.default.string
};